import EditScenePreviewController from './EditScenePreviewController';

export default EditScenePreviewController;
